export default __webpack_public_path__ + "static/media/studyPicMobile.0c12f052.png";